export * as actionCatalog from '@wix/auto_sdk_automations_action-catalog/schemas';
export * as activationActionLog from '@wix/auto_sdk_automations_activation-action-log/schemas';
export * as activationLog from '@wix/auto_sdk_automations_activation-log/schemas';
export * as activationActionSummary from '@wix/auto_sdk_automations_activation-action-summary/schemas';
export * as storageItem from '@wix/auto_sdk_automations_storage-item/schemas';
export * as triggerCatalog from '@wix/auto_sdk_automations_trigger-catalog/schemas';
export * as automationsService from '@wix/auto_sdk_automations_automations-service/schemas';
export * as customTrigger from '@wix/auto_sdk_automations_custom-trigger/schemas';
export * as activations from '@wix/auto_sdk_automations_activations/schemas';
export * as automationsV2 from '@wix/auto_sdk_automations_automations-v-2/schemas';
export * as automationTemplates from '@wix/auto_sdk_automations_automation-templates/schemas';
